import { render, staticRenderFns } from "./TransactionsItemCart.vue?vue&type=template&id=c2e5f51c&scoped=true&"
import script from "./TransactionsItemCart.vue?vue&type=script&lang=js&"
export * from "./TransactionsItemCart.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsItemCart.vue?vue&type=style&index=0&id=c2e5f51c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e5f51c",
  null
  
)

export default component.exports